import { BodyText, Button, HeadingText, Tile } from '@paypalcorp/pp-react';
import React from 'react';
import { getUserType } from '../../utils/buttonFactoryUtils';
import getLocaleMessages from '../../utils/localesMessages';
import Illustration from '../illustrations/Illustration';

const { countryNotSupported: { header, msg, button } = {} } = ({} =
  getLocaleMessages('buttonsV3/errors'));

const CountryNotSupportedTile = () => {
  const goToDashboard = () => {
    const userType = getUserType();
    window.location.pathname =
      userType === 'BUSINESS' ? '/mep/dashboard' : '/myaccount/summary';
  };

  return (
    <Tile className="country-not-supported-tile">
      <Illustration type="critical"></Illustration>
      <HeadingText className="country-not-supported-header" size="lg">
        {header}
      </HeadingText>
      <BodyText className="country-not-supported-msg">{msg}</BodyText>
      <Button
        type="submit"
        onClick={goToDashboard}
        className="go-dashboard-btn"
      >
        {button}
      </Button>
    </Tile>
  );
};

export default CountryNotSupportedTile;
